import { render, staticRenderFns } from "./billdetailed.vue?vue&type=template&id=c19e694c&"
import script from "./billdetailed.vue?vue&type=script&lang=ts&"
export * from "./billdetailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "billdetailed.vue"
export default component.exports